var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.componentName(),{tag:"component",attrs:{"poll":_vm.poll,"isActive":_vm.isActive,"voteInProgress":_vm.voteInProgress},on:{"endPoll":_vm.triggerPollEnd,"vote":_vm.handleVote}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }